import type { components } from "@/api-schema";
import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { canDeleteOwnRelocationOrder } from "@/common/hooks/relocation-order/_helpers/can-delete-own-relocation-order";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function setRelocationOrderPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.FitIntModerator)) {
    can(Action.Manage, "RelocationOrder");
  } else {
    can(Action.Delete, "RelocationOrder", (relocationOrder: RelocationOrder) =>
      canDeleteOwnRelocationOrder(relocationOrder, user.uuid),
    );
  }
}
